import moment from 'moment';

// Takes a datetime, and formats it to the
// least size, so:
// Date is today: return hh:mm
// Date is within 7 days: return day name, dd
// Date is within the last year: return dd mmm
// Date is older than 1 year: return dd mmm yy

function toLeastDateUTCFormatter(value: any) {
  if (value) {
    const theDate = moment.utc(value);

    const date = moment(value).format('YYYY-MM-DD HH:mm:ss');

    // console.log('UTC DATE:' + date); // 2015-09-13 03:39:27

    const stillUtc = moment.utc(date).toDate();
    const local = moment(stillUtc)
      .local()
      .format('YYYY-MM-DD HH:mm:ss');

    // console.log(local); // 2015-09-13 09:39:27
    // console.log('LOCAL DATE:' + local);

    // console.log('Processing toLeastDate: UTC:' + theDate.toString());
    // console.log('Processing toLeastDate: LOCAL' + theDate.local().toString());
    const currentDate: Date = new Date();
    if (isToday(theDate)) {
      // console.log('LeastDate: is today');
      // console.log('LeastDate: is today: UTC:' + theDate.toString());
      // console.log('LeastDate: is today: Local:' + theDate.local().toString());
      return theDate.local().format('HH:mm');
    } else if (isLastSevenDays(theDate)) {
      // console.log('LeastDate: is last seven days');
      return theDate.local().format('dddd');
    } else if (isLastYear(theDate)) {
      // console.log('LeastDate: is last year');
      return theDate.local().format('DD MMM');
    } else {
      // console.log('LeastDate: is older');
      return theDate.local().format('DD MMM YY');
    }
  } else {
    return '';
  }
}

function isToday(theDate: moment.Moment): boolean {
  const referenceDate = moment.utc();

  // console.log('LeastDate.isToday: RefDate: ' + referenceDate.toString());
  return theDate.dayOfYear() === referenceDate.dayOfYear();
}

function isLastSevenDays(theDate: moment.Moment): boolean {
  const referenceDate = moment.utc().subtract(7, 'days');
  // console.log('LeastDate.isLastSevenDays: RefDate: ' + referenceDate.toString());
  // console.log('LeastDate.isLastSevenDays: Result: ' + referenceDate.isAfter(theDate));
  return theDate.isAfter(referenceDate, 'day');
}

function isLastYear(theDate: moment.Moment): boolean {
  const referenceDate = moment.utc().subtract(1, 'years');
  // console.log('LeastDate.isLastYear: RefDate: ' + referenceDate.toString());
  // console.log('LeastDate.isLastYear: Result: ' + referenceDate.isAfter(theDate));
  return referenceDate.isAfter(theDate, 'day');
}
export default toLeastDateUTCFormatter;
